import { render, staticRenderFns } from "./ButtonMakePrimary.vue?vue&type=template&id=61a61645&scoped=true"
import script from "./ButtonMakePrimary.vue?vue&type=script&lang=ts"
export * from "./ButtonMakePrimary.vue?vue&type=script&lang=ts"
import style0 from "./ButtonMakePrimary.vue?vue&type=style&index=0&id=61a61645&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a61645",
  null
  
)

export default component.exports